import { useMutation } from "@tanstack/react-query";
import { StudyDataType } from "@/types/apiTypes";
import { removeStudyFromProjectAPI } from "@/API/removeStudyFromProjectApi";
import { useInvalidateQueries } from "@/hooks/helperHooks/useInvalidateQueries";
import { ShowNotification } from "@/components/ShowNotification";

type RemovePayload = {
  study: StudyDataType;
  projectId: string;
};

export const useRemoveStudyFromProject = () => {
  const { invalidateStudies, invalidateStudy, invalidateProjects } =
    useInvalidateQueries();

  return useMutation<void, Error, RemovePayload>({
    mutationFn: ({ study, projectId }) =>
      removeStudyFromProjectAPI(study, projectId),
    onSuccess: (_, { study }) => {
      if (study.id) {
        invalidateStudy(study.id);
      }
      invalidateStudies();
      invalidateProjects();
      ShowNotification({
        title: "Success",
        message: "The study has been removed from the project.",
        color: "info",
      });
    },
    onError: () => {
      ShowNotification({
        title: "Error",
        message: "Failed to remove the study from the project.",
        color: "error",
      });
    },
  });
};
